import {Nut_Settings_User} from 'nutshell-core/settings-constants';

import {Illustration} from 'shells/illustrations/illustration';
import {PromoBanner} from 'shells/promo-banner/promo-banner';

import {useDismissibleUserSetting} from '../../../../util/hooks/use-dismissible-user-setting';

export function ChatbotReportCard() {
    const {shouldShow, onDismiss} = useDismissibleUserSetting(
        Nut_Settings_User.SETTING_HAS_DISMISSED_CHATBOT_REPORT_BANNER
    );

    const handleDismiss = () => {
        onDismiss?.();
    };

    if (!shouldShow) {
        return null;
    }

    return (
        <PromoBanner
            illustration={<Illustration src='chatbot-report' width={276} />}
            title='Chatbot report'
            description='Measure chatbot performance and visitor interests.'
            ctaText='Go to Chatbot report'
            ctaHref='/reports/chatbot'
            onDismiss={handleDismiss}
        />
    );
}
